
























































































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { StepMixin, StepStoreMixin, StoreFileMixin, ErrorResponseMixin, PopupMixin } from '@mixin';
import axios from 'axios';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            next: {
                disabled: true,
            },
            showProjectPlanFields: false,
            store: {
                title: null,
                plan: {
                    idea_description: null,
                    idea_origin: null,
                    collaboration_organisations: null,
                    idea_goals: null,
                    benefits_from_idea: null,
                    means_of_contact: null,
                    realisation_where_when: null,
                }
            },
            post: {
                file: null,
                owner: 'project',
                type: 'projectplan',
            },
        };
    },

    mixins: [
        StepMixin,
        StepStoreMixin,
        StoreFileMixin,
        ErrorResponseMixin,
        PopupMixin
    ],

    created() {
        this.post.id = this.current.id;
        this.downloadFile(this.post);
    },

    methods: {
        toggleProjectPlanFields() {
            this.showProjectPlanFields = !this.showProjectPlanFields;
        },

        async onNext() {
            return await this.$validator.validate().then(valid => {
                if (!valid) return;
                return this.storeFile(this.post);
            });
        },

        onPropsFilled() {
            const arr = [
                'idea_description',
                'idea_origin',
                'collaboration_organisations',
                'idea_goals',
                'benefits_from_idea',
                'means_of_contact',
                'realisation_where_when',
            ];

            arr.some(key => {
                if (this.store[key]) {
                    this.showProjectPlanFields = true;
                    return true;
                }
            });
        }
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Projectplan extends Vue {
    @Watch('store.title')
    onTitleChange(val) {
        this.$validator.validate().then(valid => {
            this.next.disabled = !valid;
        });
    }
}

